import styled from "styled-components";

interface ImagePropsType {
  width?: string;
  height?: string;
  margin?: string;
  padding?: string;
  borderRadius?: string;
  position?: string;
  top?: string;
  right?: string;
  bottom?: string;
  left?: string;
  cursorPointer?: boolean;
}

export const Img = styled.img<ImagePropsType>`
  ${p => p.margin && `margin: ${p.margin}`};
  ${p => p.padding && `padding: ${p.padding}`};
  ${p => p.position && `position: ${p.position}`};
  ${p => p.top && `top: ${p.top}`};
  ${p => p.right && `right: ${p.right}`};
  ${p => p.bottom && `bottom: ${p.bottom}`};
  ${p => p.left && `left: ${p.left}`};
  ${p => p.cursorPointer && `cursor: pointer`};
  ${p => p.borderRadius && `border-radius: ${p.borderRadius}`};

  width: ${p => p.width || "auto"};
  height: ${p => p.height || "100%"};
`;
